
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["prt-icon prt-option-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 122.49 84.6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 84.6h91.74v-1.73H0zm93.92-3.91h28.57v-1.7H93.92zm0-3.91h25.74V62.41L93.92 51.08zm-19.86-73V14l10.32 6.75v-17z","fill":"#9b9c9e"}}),_c('path',{attrs:{"d":"M54.2 54.94h28.94v9.07H54.2zM25.44 34.53h21.38v9.07H25.44zm28.76 0h21.38v9.07H54.2zM50.51 0L0 34.53h9.28v46.16h16.16V52.12h21.38v28.57h44.92V34.53h9.28z","fill":"#b0b2b3"}}),_c('path',{staticClass:"prt-icon-color",attrs:{"d":"M26.86 53.54h18.55v27.15H26.86z"}})])
          )
        }
      }
    